var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6771 5.45837C50.1235 5.02877 50.9479 3.50791 50.5183 2.06143C50.0886 0.614962 48.5678 -0.20937 47.1213 0.220236L4.7964 12.7908C2.0936 13.1202 0 15.423 0 18.2147V21.4019H51V18.2147C51 15.1969 48.5536 12.7504 45.5357 12.7504H24.1249L48.6771 5.45837ZM51 25.9555H0V45.5362C0 48.554 2.44644 51.0004 5.46429 51.0004H45.5357C48.5536 51.0004 51 48.554 51 45.5362V25.9555ZM15.8055 44.9196C19.4891 44.9196 22.4753 41.9334 22.4753 38.2497C22.4753 34.5661 19.4891 31.5799 15.8055 31.5799C12.1218 31.5799 9.1356 34.5661 9.1356 38.2497C9.1356 41.9334 12.1218 44.9196 15.8055 44.9196ZM34.6071 32.0815C33.3497 32.0815 32.3304 33.1008 32.3304 34.3583C32.3304 35.6157 33.3497 36.6351 34.6071 36.6351H40.0714C41.3289 36.6351 42.3482 35.6157 42.3482 34.3583C42.3482 33.1008 41.3289 32.0815 40.0714 32.0815H34.6071ZM32.3304 43.4654C32.3304 42.208 33.3497 41.1886 34.6071 41.1886H40.0714C41.3289 41.1886 42.3482 42.208 42.3482 43.4654C42.3482 44.7229 41.3289 45.7422 40.0714 45.7422H34.6071C33.3497 45.7422 32.3304 44.7229 32.3304 43.4654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/Radio.fe8f83fb6e8875f849cc8e31a9b65f7b.svg";
export { ForwardRef as ReactComponent };